if ( typeof QuickAddToCart !== 'function' ) {

	class QuickAddToCart extends HTMLElement {
		constructor(){
			super();
			if ( this.querySelector('product-form') ) {
				this.init();
			}
		}
		init(){
			this.querySelector('product-form').addEventListener('add-to-cart', ()=>{
				if ( ! document.body.classList.contains('template-cart') ) {
					// VitaFresh: kein Auto-Open des Cart-Drawers beim Hinzufügen — nur Badge updaten
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						const t = document.querySelector('#AjaxCartForm [data-cart-total]');
						if (t) elm.textContent = t.textContent;
					});
					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						// VitaFresh (21.10.2026): angezeigte Zahl ohne Kühltasche (snippets/vf-korb-anzahl.liquid)
						const c = document.querySelector('#AjaxCartForm [data-cart-count-anzeige]') || document.querySelector('#AjaxCartForm [data-cart-count]');
						if (c) elm.textContent = c.textContent.trim();
					});
				}
			});
		}
	}

  if ( typeof customElements.get('quick-add-to-cart') == 'undefined' ) {
		customElements.define('quick-add-to-cart', QuickAddToCart);
	}

}

if ( typeof QuickViewProduct !== 'function' ) {

	class QuickViewProduct extends HTMLElement {
		constructor(){
			super();
			if ( this.querySelector('a') ) {
				this.init();
			}
		}
		init(){

			this.quickViewModal = null;
			this.querySelector('a').addEventListener('click', (e)=>{

				e.preventDefault();

				if ( ! this.quickViewModal ) {

					const target = e.currentTarget;

					target.classList.add('working');

					fetch(`${target.getAttribute('href')}${ target.getAttribute('href').includes('?') ? '&' : '?' }view=quick-view`)
						.then(response => response.text())
						.then(text => {

							const quickViewHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('#product-quick-view');

							// create modal w content

							const quickViewContainer = document.createElement('div');
							quickViewContainer.innerHTML = `<modal-box id="modal-${target.dataset.id}"	
								class="modal modal--product" 
								data-options='{
									"enabled": false,
									"showOnce": false,
									"blockTabNavigation": true
								}'
								tabindex="-1" role="dialog" aria-modal="true" 
							>
								<div class="container--large">
									<div class="modal-content">
										<button class="modal-close" data-js-close data-js-first-focus style="position:absolute;margin:0;top:0;right:0">${window.KROWN.settings.symbols.close}</button>
									</div>
								</div>
								<span class="modal-background" data-js-close></span>
							</modal-box>`;

							this.quickViewModal = quickViewContainer.querySelector('modal-box');
							document.body.appendChild(this.quickViewModal);

							this.quickViewModal.querySelector('.modal-content').innerHTML = quickViewHTML.innerHTML;

							if ( ! window.productPageScripts ) {
									
								const scripts = this.quickViewModal.querySelectorAll('script');
								scripts.forEach(elm=>{
									const script = document.createElement('script');
									script.src = elm.src;
									document.body.append(script);
									window.productPageScripts = true;
								})

							}

							this.quickViewModal.querySelector('.product-quick-view__close').addEventListener('click', ()=>{
								this.quickViewModal.hide();
							});

							if ( this.quickViewModal.querySelector('[data-js-product-form]') ) {
								this.quickViewModal.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
									this.quickViewModal.hide();
								});
							}

							setTimeout(()=>{
								this.quickViewModal.show();
								target.classList.remove('working');
							}, 250);
							
						});

				} else {
					this.quickViewModal.show();
				}

			})
		}
	}

  if ( typeof customElements.get('quick-view-product') == 'undefined' ) {
		customElements.define('quick-view-product', QuickViewProduct);
	}

}

/* VitaFresh (17.10.2026, aus «XO Insert Code» übernommen): Grössenwahl in der alten Schnellansicht
   (sections/product-quick-view.liquid, Gericht-Links in Blog-Beiträgen) schreibt die Nährwerte der gewählten Grösse
   in die Kreise; fehlt ein Wert, steht «–» statt der Zahl der vorigen Grösse. Delegiert am Dokument (die Schnellansicht
   wird nachgeladen), auf change, damit auch die Pfeiltasten der Radio-Gruppe greifen. */
if ( typeof window.vfQvGroesse == 'undefined' ) {
	window.vfQvGroesse = true;
	document.addEventListener('change', function (event) {
		const target = event.target.closest ? event.target.closest('[data-component~="product-variation-switch"]') : null;
		if ( !target ) return;
		const product = target.closest('[data-component~="product"]');
		if ( !product ) return;
		product.querySelectorAll('[data-component~="product-nutrition-item-value"]').forEach(function (value) {
			const id = value.getAttribute('data-id');
			const wert = (target.getAttribute('data-' + id) || '').trim();
			value.textContent = wert === '' ? '–' : (id == 'weight' ? wert.replace(/\s*g$/i, '') : wert); /* Gewicht ohne «g» wie beim Laden */
		});
	});
}
